import EnrolmentsSerializer from './base';

export default class Ping extends EnrolmentsSerializer {}
